<app-header></app-header>
<ngx-spinner></ngx-spinner>
<div class="row pb-2 mt-4 ml-1 mr-1">
    <div class="col">
      <h4>
        <div>{{ CreateShowHide ? 'Add Case Pack' : UpdateShowHide ? 'Edit Case Pack': 'Case Packs'}} </div>
      </h4>
    </div>
</div>

<div class="row mb-2 ml-1 mr-1">
  <div class="col-sm-3">
    <input type="text" *ngIf="!(CreateShowHide || UpdateShowHide)" class="form-control" placeholder="Search" [(ngModel)]="filter">
  </div>
  <div class="col">
    <button type="button" *ngIf="AddShowHide" class="btn btn-success float-right" aria-controls="AddCasePack" (click)="AddCasePack()">
      <i class="fas fa-plus-circle"></i> <span>Add Case Pack</span>
    </button>
  </div>
</div>

<form [formGroup]="frmCasePack" *ngIf="CreateShowHide || UpdateShowHide">
  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">

        <div class="form-group col-lg-3" *ngIf="CreateShowHide === true">
          <label for="txtNomenclature">Nomenclature</label><span style="color:red;">&nbsp;*</span>
          <select class="form-control" formControlName="Nomenclature" id="txtNomenclature" [(ngModel)]="selectedNomenclature" (change)="changeNomenclature($event)" required>                            
            <option [ngValue]="product.nomenclature" *ngFor="let product of products" >{{product.nomenclature}} 
            </option>
          </select>
        </div>
        <div class="form-group col-lg-3" *ngIf="CreateShowHide === false">
          <label for="txtNomenclature">Nomenclature</label>
          <input class="form-control" formControlName="Nomenclature" id="txtNomenclature" readonly="readonly">
        </div>
        
        <!--<div class="form-group col-lg-3" *ngIf="CreateShowHide === true">
          <label for="txtPrintGroup">Print Group</label><span style="color:red;">&nbsp;*</span>
          <select class="form-control" formControlName="PrintGroup" id="txtPrintGroup" required>
            <option selected disabled value="">Choose...</option>
            <option [ngValue]="printgroup.PrintGroup1" *ngFor="let printgroup of printgroups">
              {{printgroup.PrintGroup1}} </option>
          </select>
        </div>-->
        <div class="form-group col-lg-3" *ngIf="CreateShowHide === true">
          <label for="txtPrintGroup">Print Group</label><span style="color:red;"> *</span>
          <select class="form-control" formControlName="PrintGroup" id="txtPrintGroup" required>
            <option selected disabled value="">Choose...</option>
            <option [ngValue]="product.printGroup" *ngFor="let product of filteredItems">
              {{product.printGroup}} </option>
          </select>
        </div>
        <div class="form-group col-lg-3" *ngIf="CreateShowHide === false">
          <label for="txtPrintGroup">Print Group</label>
          <input class="form-control" formControlName="PrintGroup" id="txtPrintGroup" readonly="readonly">
        </div>
       
        <div class="form-group col-lg-2">
          <label for="txtCasePack">Case Pack</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtCasePack" formControlName="CasePack" required>
        </div>
        
        <div class="form-group col-lg-2">
          <label for="txtIsDefault">Is Default</label><span style="color:red;">&nbsp;*</span>
          <select class="form-control" formControlName="IsDefault" id="txtIsDefault" required>
            <option [ngValue]="true">Yes </option>
            <option [ngValue]="false">No </option>
          </select>
        </div>
      
      </div>
    </div>
  </div>

  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">
        
        <div class="form-group col-lg-3">
          <label for="txtScc">SCC</label>
          <input type="text" class="form-control" id="txtScc" formControlName="SCC">
        </div>

        <div class="form-group col-lg-3">
          <label for="txtUpc">UPC</label>
          <input type="text" class="form-control" id="txtUpc" formControlName="UPC">
        </div>
       
        <div class="form-group col-lg-3">
          <label for="txtPart">Part</label>
          <input type="text" class="form-control" id="txtPart" formControlName="Part">
        </div>

      </div>
    </div>
  </div>

  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">

        <div class="form-group col-lg-2">
          <label for="txtWeight">Weight</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtWeight" formControlName="Weight" required>
        </div>

        <div class="form-group col-lg-2">
          <label for="txtCube">Cube</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtCube" formControlName="Cube" required>
        </div>


        <div class="form-group col-lg-2">
          <label for="txtLength">Length</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtLength" formControlName="Length" required>
        </div>

        <div class="form-group col-lg-2">
          <label for="txtHeight">Height</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtHeight" formControlName="Height" required>
        </div>

        <div class="form-group col-lg-2">
          <label for="txtWidth">Width</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtWidth" formControlName="Width" required>
        </div>

      </div>
    </div>
  </div>

  <div class="row ml-1 mr-1">
    <div class="col">
      <div class="form-row">

        <div class="form-group col-lg-2">
          <label for="txtPallets">Pallets</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtPallets" formControlName="Pallets" required>
        </div>

        <div class="form-group col-lg-2">
          <label for="txtTi">Ti</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtTi" formControlName="Ti" required>
        </div>

        <div class="form-group col-lg-2">
          <label for="txtHi">Hi</label><span style="color:red;">&nbsp;*</span>
          <input type="text" class="form-control" id="txtHi" formControlName="Hi" required>
        </div>
        <div class="form-group col-lg-2">
          <label for="txtSleeveQuantity">Sleeve Quantity</label>
          <input type="text" class="form-control" id="txtSleeveQuantity" formControlName="SleeveQuantity">
        </div>
        <div class="form-group col-lg-2">
          <label for="txtSleeves">Sleeves</label>
          <input type="text" class="form-control" id="txtSleeves" formControlName="Sleeves">
        </div>
    </div>
  </div>
  </div>

  <div class="row ml-1 mr-1">
    <div class="col">
      <button type="button" class="btn btn-success" [disabled]="frmCasePack.invalid" *ngIf="CreateShowHide" (click)="CreateCasePack()">
        <i class="fas fa-pen" area-hidden="true"></i> <span class="d-none d-md-inline d-lg-inline">Submit</span>
      </button>
      <button type="button" class="btn btn-success" [disabled]="frmCasePack.invalid" *ngIf="UpdateShowHide" (click)="UpdateCasePack()">
        <i class="fas fa-pen" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Update</span>
      </button>  
      <a>
        <button type="button" aria-controls="addCasePack" *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary">
          <i class="fas fa-undo" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Cancel</span>
        </button>
      </a>
    </div>
</div>

</form>



<!-- <main role="main" class="flex-shrink-0">
    <div class="container-fluid mt-5 mb-4"> -->
      <!-- <div class="row pb-2">
        <div class="col">
            <h4>Case Packs</h4>
        </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-3">
        <input type="text" class="form-control" placeholder="Search" [(ngModel)]="filter">
    </div>
        <div class="col">
            <button type="button" *ngIf="AddShowHide" class="btn btn-success float-right" data-toggle="modal"
            data-target="#addCasePack"  aria-controls="AddCasePack" (click)="AddCasePack()"><i
            class="fas fa-plus-circle"></i> Add Case Pack</button>

        </div>
    </div>
    <div class="modal fade" id="addCasePack"tabindex="-1" #addCasePack aria-labelledby="addCasePackTitle"aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role=document>
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="addCasePackTitle">Enter Case Pack Information</h5>
                <button type="button" class="close" data-dismiss="modal" (click)="Cancel()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
                <div class="modal-body">
                    <form [formGroup]="frmCasePack">
                        <div class="form-row">

                          <div class="col-md-3 mb-2" *ngIf="CreateShowHide === true ">
                            <label for="txtNomenclature">Nomenclature</label><span style="color:red;">&nbsp;*</span>
                            <select class="form-control" formControlName="Nomenclature" id="txtNomenclature" required>                            
                              <option [ngValue]="product.nomenclature" *ngFor="let product of products">{{product.nomenclature}}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-3 mb-2" *ngIf="CreateShowHide === false ">
                            <label for="txtNomenclature">Nomenclature</label>
                            <input class="form-control" formControlName="Nomenclature" id="txtNomenclature" readonly="readonly">
              
                          </div>
              
                          <div class="col-md-3 mb-2" *ngIf="CreateShowHide === true ">
                            <label for="txtPrintGroup">Print Group</label><span style="color:red;">&nbsp;*</span>
                            <select class="form-control" formControlName="PrintGroup" id="txtPrintGroup" required>
                              <option selected disabled value="">Choose...</option>
                              <option [ngValue]="printgroup.PrintGroup1" *ngFor="let printgroup of printgroups">
                                {{printgroup.PrintGroup1}} </option>
                            </select>
                          </div>
              
                          <div class="col-md-3 mb-2" *ngIf="CreateShowHide === false ">
                            <label for="txtPrintGroup">Print Group</label>
                            <input class="form-control" formControlName="PrintGroup" id="txtPrintGroup" readonly="readonly">
                          </div>
                          <div class="col-md-3 mb-2">
                            <label for="txtCasePack">Case Pack</label><span style="color:red;">&nbsp;*</span>
                            <input type="text" class="form-control" id="txtCasePack" formControlName="CasePack" required>
                          </div>
                          <div class="col-md-3 mb-2">
                            <label for="txtIsDefault">Is Default</label><span style="color:red;">&nbsp;*</span>
                            <select class="form-control" formControlName="IsDefault" id="txtIsDefault" required>
                              <option [ngValue]="true">Yes </option>
                              <option [ngValue]="false">No </option>
              
                            </select>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="txtScc">SCC</label>
                            <input type="text" class="form-control" id="txtScc" formControlName="SCC">
                          </div>
              
                          <div class="col-md-4 mb-2">
                            <label for="txtUpc">UPC</label>
                            <input type="text" class="form-control" id="txtUpc" formControlName="UPC">
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="txtPart">Part</label>
                            <input type="text" class="form-control" id="txtPart" formControlName="Part">
                          </div>
              
                          <div class="col-md-3 mb-2">
                            <label for="txtWeight">Weight</label><span style="color:red;">&nbsp;*</span>
                            <input type="text" class="form-control" id="txtWeight" formControlName="Weight" required>
                          </div>
              
                          <div class="col-md-3 mb-2">
                            <label for="txtCube">Cube</label><span style="color:red;">&nbsp;*</span>
                            <input type="text" class="form-control" id="txtCube" formControlName="Cube" required>
                          </div>
              
              
                          <div class="col-md-3 mb-2">
                            <label for="txtLength">Length</label><span style="color:red;">&nbsp;*</span>
                            <input type="text" class="form-control" id="txtLength" formControlName="Length" required>
                          </div>
              
                          <div class="col-md-3 mb-2">
                            <label for="txtHeight">Height</label><span style="color:red;">&nbsp;*</span>
                            <input type="text" class="form-control" id="txtHeight" formControlName="Height" required>
                          </div>
              
                          <div class="col-md-2 mb-2">
                            <label for="txtWidth">Width</label><span style="color:red;">&nbsp;*</span>
                            <input type="text" class="form-control" id="txtWidth" formControlName="Width" required>
                          </div>
              
                          <div class="col-md-2 mb-2">
                            <label for="txtPallets">Pallets</label><span style="color:red;">&nbsp;*</span>
                            <input type="text" class="form-control" id="txtPallets" formControlName="Pallets" required>
                          </div>
              
                          <div class="col-md-2 mb-2">
                            <label for="txtTi">Ti</label><span style="color:red;">&nbsp;*</span>
                            <input type="text" class="form-control" id="txtTi" formControlName="Ti" required>
                          </div>
              
                          <div class="col-md-2 mb-2">
                            <label for="txtHi">Hi</label><span style="color:red;">&nbsp;*</span>
                            <input type="text" class="form-control" id="txtHi" formControlName="Hi" required>
                          </div>
                          <div class="col-md-2 mb-2">
                            <label for="txtSleeveQuantity">Sleeve Quantity</label>
                            <input type="text" class="form-control" id="txtSleeveQuantity" formControlName="SleeveQuantity">
                          </div>
                          <div class="col-md-2 mb-2">
                            <label for="txtSleeves">Sleeves</label>
                            <input type="text" class="form-control" id="txtSleeves" formControlName="Sleeves">
                          </div>
                    </div>
                    <div class="modal-footer">
                      <div class="row">
                        <div class="col-md-6">
                          <button type="button" class="btn btn-success" *ngIf="CreateShowHide"
                            (click)="CreateCasePack()">Add</button>
                          <button type="button" class="btn btn-success" [disabled]="frmCasePack.invalid" *ngIf="UpdateShowHide"
                            data-toggle="modal" data-dismiss="modal" (click)="UpdateCasePack()">Update</button>
                        </div>
                        <div class="col-md-6">
                          <button type="button" data-target="#addCasePack" data-toggle="modal" aria-controls="addCasePack"
                            *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary"
                            data-dismiss="modal">Cancel</button>
                        </div>
                      </div>
                    </div>
                    </form>
                </div>
            </div>

        </div>
    </div> -->
    <div class="row ml-1 mr-1" *ngIf="!(CreateShowHide || UpdateShowHide)">
        <div class="col">
            <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col" *ngIf="EditShowHide">Actions</th>
                            <th scope="col"><span (click)="SortOder('Nomenclature', reverse)">Nomenclature <i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('PrintGroup', reverse)">Print Group <i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('CasePack', reverse)">  Case Pack<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('SCC', reverse)"> SCC <i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('UPC', reverse)"> UPC <i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Weight', reverse)" > Weight<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Cube', reverse)" > Cube<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Length', reverse)">  Length<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Height', reverse)">  Height<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Width', reverse)">  Width<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Pallets', reverse)">  Pallets<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Ti', reverse)">  Ti<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Hi', reverse)" > Hi<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Sleeve Quantity', reverse)" > Sleeve Quantity<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Sleeves', reverse)">  Sleeves<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('Part', reverse)">  Part<i class="fas fa-sort"></i></span></th>
                            <th scope="col"><span (click)="SortOder('IsDefault', reverse)">  Is Default<i class="fas fa-sort"></i></span></th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items | stringFilter: filter | paginate: config ">
                            <td *ngIf="EditShowHide">
                              <tr>
                                <td>
                                  <button type="button"  data-target="#addCasePack" data-toggle="modal" class="btn btn-info btn-sm"
                                (click)="EditCasePack(item)" title="Edit"><i class="fas fa-pen"></i> <span class="d-none d-md-inline d-lg-inline">Edit</span>
                                </button>
                                </td>
                                <td>
                                  <button class="btn btn-info btn-sm" (click)="DeleteCasePack(item.id)" title="Delete">
                                    <i class="far fa-trash-alt fa-lg text-danger"></i>
                                    <span class="d-none d-md-inline d-lg-inline">Delete</span>
                                </button>
                                </td>
                              </tr>
                            </td>
                            <td >{{item.nomenclature}}</td>
                            <td>{{item.printGroup}}</td>
                            <td>{{item.casePack1}}</td>
                            <td>{{item.sc}}</td>
                            <td>{{item.upc}}</td>
                            <td>{{item.weight}}</td>
                            <td>{{item.cube}}</td>
                            <td>{{item.length}}</td>
                            <td>{{item.height}}</td>
                            <td>{{item.width}}</td>
                            <td>{{item.pallets}}</td>
                            <td>{{item.ti}}</td>
                            <td>{{item.hi}}</td>
                            <td>{{item.sleeveQuantity}}</td>
                            <td>{{item.sleeves}}</td>
                            <td>{{item.part}}</td>
                            <td>{{item.isDefault}}</td>
                        </tr>

                    </tbody>
                </table>

            </div>
        </div>
    </div>
    <div class="row ml-1 mr-1" *ngIf="!(CreateShowHide || UpdateShowHide)">
      <div class="col mtpx">
          {{
          (config.totalItems === 0) ? 'No records found' : 'Showing ' +
          (
          ((config.currentPage - 1) * config.itemsPerPage + 1) +
          (((config.currentPage * config.itemsPerPage) > config.totalItems) ? ((config.totalItems <= 1 ? '' : ('
              - ' + config.totalItems))) : ((' - ' + config.currentPage
              *
              config.itemsPerPage))) + ' of ' + config.totalItems + ' records.' ) }} </div>
              <div class="col">
                  <pagination-controls [id]="config.id" [autoHide]="true" [responsive]="true"
                      (pageChange)="onPageChange($event)" (pageBoundsCorrection)="onPageBoundsCorrection($event)"
                      class="pagination justify-content-end mtpx">
                  </pagination-controls>
              </div>
      </div>
<!-- </div>
</main> -->

<!-- <div class="grid-table">
  <div class ="thead">
    <div class="tr">
      <div class="td">Nomenclature</div>
      <div class="td">Printgroup</div>
      <div class="td">SCC</div>
      <div class="td">UPC</div>
      <div class="td">Casepack1</div>
      <div class="td">Weight</div>
      <div class="td">Cube</div>
      <div class="td">Length</div>
      <div class="td">Height</div>
      <div class="td">Width</div>
      <div class="td">Pallets</div>
      <div class="td">Ti</div>
      <div class="td">Hi</div>
      <div class="td">Sleeve Quantity</div>
      <div class="td">Sleeves</div>
      <div class="td">Part</div>
      <div class="td">Is Default</div>
      <div class ="td">
        <button class = "btn btn-outline-success" (click) = "addCasePackForm()">
          <i class="fa fa-plus"></i> New Case Pack
        </button>
      </div>
      <div class="td">
        <span *ngIf="notification" class="elementToFadeInAndOut">
          <i class="fas fa-check-circle {{notification.class}}"></i>
          {{notification.message}}
        </span>
      </div>
    </div>
  </div>
  <div class="tbody">
    <form class = "tr" [formGroup] = "fg" *ngFor="let fg of casePackForms.controls; let i=index;" (submit)="recordSubmit(fg)">
    <div class="td">
      <input class="form-control" formControlName="nomenclature">
    </div>
    <div class="td">
      <input class="form-control" formControlName="printgroup">
    </div>
    <div class="td">
      <input class="form-control" formControlName="scc">
    </div>
    <div class="td">
      <input class="form-control" formControlName="upc">
    </div>
    <div class="td">
      <input class="form-control" formControlName="casepack1">
    </div>
    <div class="td">
      <input class="form-control" formControlName="weight">
    </div>
    <div class="td">
      <input class="form-control" formControlName="cube">
    </div>
    <div class="td">
      <input class="form-control" formControlName="length">
    </div>
    <div class="td">
      <input class="form-control" formControlName="height">
    </div>
    <div class="td">
      <input class="form-control" formControlName="width">
    </div>
    <div class="td">
      <input class="form-control" formControlName="pallets">
    </div>
    <div class="td">
      <input class="form-control" formControlName="ti">
    </div>
    <div class="td">
      <input class="form-control" formControlName="hi">
    </div>
    <div class="td">
      <input class="form-control" formControlName="sleevequantity">
    </div>
    <div class="td">
      <input class="form-control" formControlName="sleeves">
    </div>
    <div class="td">
      <input class="form-control" formControlName="part">
    </div>
    <div class="td">
      <input class="form-control" formControlName="isdefault">
    </div>
    <div class="td">
      <button type="submit" class="btn" [disabled]="fg.invalid"
          [ngClass]="(fg.get('id').value==0)?'btn-success':'btn-outline-dark'"><i
              class="far fa-save fa-lg"></i>
          {{fg.get('id').value==0?'Submit':'Update'}}
      </button>
    </div>
    <div class ="td">
      <button class="btn btn-light ml-1" (click)="onDelete(fg.get('id').value,i)">
          <i class="far fa-trash-alt fa-lg text-danger"></i>
          {{'Delete'}}
      </button>
  </div>
    </form>
    </div>
</div> -->
